<div class="main-content" fxFlex fxLayout="column">
	<cdk-virtual-scroll-viewport #virtualViewport [itemSize]="100" fxFlex>
		<ng-content></ng-content>
	</cdk-virtual-scroll-viewport>
</div>
